import Vue from 'vue'
import masker from '@/shared/mask/masker'
import moment from 'vue-moment-lib'

Vue.filter('toCnpj', (value) => {
    return masker(value, '##.###.###/####-##')
})

Vue.filter('toCpf', (value) => {
    return masker(value, '###.###.###-##')
})

Vue.filter('toCpfAnonimizado', (value) => {
    if (!value) return ''
    const digits = String(value).replace(/\D/g, '')
    if (digits.length !== 11) return value
    return `***.${digits.slice(3, 6)}.${digits.slice(6, 9)}-**`
})

Vue.filter('toStatus', (value) => {
    return `<strong>${value}</strong>`
})

Vue.filter('toTelefone', (value) => {
    return masker(value, ['(##) #####-####', '(##) ####-####'])
})

Vue.filter('toCep', (value) => {
    return masker(value, '#####-###')
})

Vue.filter('toDate', (value) => {
    return value ? moment(value).format('DD/MM/YYYY') : ''
})

Vue.filter('toDateTime', (value) => {
    return value ? moment(value).format('DD/MM/YYYY HH:mm') : ''
})
